export default __webpack_public_path__ + "static/media/messageUnread.b720383e.svg";